import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#4B137B"
      d="M8.006 14c3.318 0 6.007-2.686 6.007-6s-2.69-6-6.007-6C4.69 2 2 4.686 2 8s2.69 6 6.006 6z"
      clipRule="evenodd"
    />
    <path stroke="#4B137B" d="M5.805 5.047 8.283 8.44h3.029" />
  </svg>
);
const Memo = memo(SvgClock);
export default Memo;
